var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"alert-container"},[_c('v-alert',{attrs:{"value":_vm.visible,"type":_vm.alert.type,"transition":"scale-transition"}},[_vm._v("\n    "+_vm._s(_vm.alert.message)+"\n  ")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }